import { render, staticRenderFns } from "./attachment.list.vue?vue&type=template&id=d8f53fcc&scoped=true&"
import script from "./attachment.list.vue?vue&type=script&lang=ts&"
export * from "./attachment.list.vue?vue&type=script&lang=ts&"
import style0 from "./attachment.list.vue?vue&type=style&index=0&id=d8f53fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f53fcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VSelect,VTextField})
